import { translateAdmin } from '../../../utils/adminTranslations';
import AdminText from '../AdminText';
import React, { useEffect, useState } from 'react';
import { apiUrl } from '../../../config'
import { fetchData } from '../../../utils/api';
import LanguageChanger from '../../../utils/modules/LanguageChanger';
import { useLanguage } from '../../../LanguageContext';

const RoomEdit = ({ room, onClose }) => {
    const { language } = useLanguage();
    const [messageEditData, setMessageEditData] = useState([])
    const [roomAvailabilities, setRoomAvailabilities] = useState([]);
    const [editRoom, setEditRoom] = useState({
        ...room, // клонируем весь объект room
        translations: {
            ...room.translations, // клонируем translations, если они есть
            additional_info: room.translations?.additional_info || { [language]: '' } // добавляем additional_info, если его нет
        }
    });
    const [newImages, setNewImages] = useState([]);
    useEffect(() => {
        const fetchRoomAvailabilities = async () => {
            const token = localStorage.getItem('accessToken');
            const response = await fetchData(`${apiUrl}/api/sys/get-room-availability`, "GET", token)
            setRoomAvailabilities(response.request.data)
        }
        fetchRoomAvailabilities()
    }, [])
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // Проверка, если имя поля связано с nested translations (например, translations.room_type.ru)
        if (name === "room_type" || name === "description" || name === "amenities" || name === "additional_info") {
            setEditRoom((prevRoom) => ({
                ...prevRoom,
                translations: {
                    ...prevRoom.translations,
                    [name]: {
                        ...prevRoom.translations[name],
                        [language]: value,  // Обновляем значение для указанного языка
                    },
                },
            }));
        } else {
            // Для других полей обновляем как обычно
            setEditRoom((prevRoom) => ({ ...prevRoom, [name]: value }));
        }
    };
    // Добавление нового удобства
    const handleAddAmenity = () => {
        setEditRoom((prevRoom) => ({
            ...prevRoom,
            translations: {
                ...prevRoom.translations,
                amenities: {
                    ...prevRoom.translations.amenities,
                    [language]: [...(prevRoom.translations.amenities[language] || []), ''], // Добавляем пустую строку для текущего языка
                },
            },
        }));
    };
    const handleAmenityChange = (index, value) => {
        setEditRoom((prevRoom) => {
            const updatedAmenities = [...(prevRoom.translations.amenities[language] || [])]; // Копируем массив удобств для текущего языка
            updatedAmenities[index] = value; // Обновляем элемент по индексу

            return {
                ...prevRoom,
                translations: {
                    ...prevRoom.translations,
                    amenities: {
                        ...prevRoom.translations.amenities,
                        [language]: updatedAmenities, // Обновляем массив для текущего языка
                    },
                },
            };
        });
    };
    const handleRemoveAmenity = (index) => {
        setEditRoom((prevRoom) => {
            const updatedAmenities = (prevRoom.translations.amenities[language] || []).filter((_, i) => i !== index); // Удаляем элемент по индексу

            return {
                ...prevRoom,
                translations: {
                    ...prevRoom.translations,
                    amenities: {
                        ...prevRoom.translations.amenities,
                        [language]: updatedAmenities, // Обновляем массив для текущего языка
                    },
                },
            };
        });
    };

    const MAX_FILES = 7;
    const MAX_VIDEO_SIZE_MB = 200;

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);

        // Проверяем общий лимит файлов
        if ((files.length + editRoom.images.length) > MAX_FILES) {
            setMessageEditData(`Можно загрузить максимум ${MAX_FILES} фото/видео. Загружено ${editRoom.images.length}`);
            e.target.value = '';
            return;
        }

        // Проверка видео по размеру
        for (let file of files) {
            if (file.type.startsWith("video/")) {
                const sizeMb = file.size / (1024 * 1024);
                if (sizeMb > MAX_VIDEO_SIZE_MB) {
                    setMessageEditData(`Видео ${file.name} слишком большое. Максимум ${MAX_VIDEO_SIZE_MB} МБ.`);
                    e.target.value = '';
                    return;
                }
            }
        }

        // Создаём превью для изображений и видео
        const filePreviews = files.map(file => ({
            name: file.name,
            preview: URL.createObjectURL(file),
            type: file.type.startsWith("video/") ? "video" : "image"
        }));

        setMessageEditData([]); // Очистка ошибок
        setNewImages(filePreviews);
        setEditRoom({ ...editRoom, images: editRoom.images, new_images: files });
    };

    const sendData = async (roomData) => {
        const formData = new FormData();
        // Добавляем текстовые данные
        for (const key in roomData) {
            if (key !== 'new_images' && key !== 'translations') {
                formData.append(key, roomData[key]);
            }
            if (key === 'translations') {
                formData.append('translations', JSON.stringify(roomData[key]));
            }
        }

        // Добавляем файлы
        if (roomData.new_images) {
            roomData.new_images.forEach((file, index) => {
                formData.append('new_images', file);  // Используем одно и то же имя 'images'
            });
        }
        // Добавляем lang_code
        formData.append('lang_code', language);
        const token = localStorage.getItem('accessToken');
        const data = await fetchData(`${apiUrl}/api/sys/edit-room`, "POST", token, { body: formData }, null)
        setMessageEditData(data.request.message)
        if (data.request.status === 0) {
            setTimeout(() => {
                setMessageEditData([])
            }, 5000)
        } else {
            setTimeout(() => {
                setMessageEditData([])
            }, 25000)
        }
    }

    const delImageVideo = async (id, fileName, type) => {
        // type = "image" или "video"
        const itemType = type === 'video' ? translateAdmin('видео') : translateAdmin('картинку');
        const isConfirmed = window.confirm(`${translateAdmin('Вы уверены, что хотите удалить')} ${itemType}?`);
        if (!isConfirmed) return;

        try {
            const token = localStorage.getItem('accessToken');
            const data = await fetchData(
                `${apiUrl}/api/sys/del-room-imgVid?id=${id}&imgVid=${fileName}`,
                "DELETE",
                token
            );

            setMessageEditData(data.request.message);

            if (data.request.status === 0) {
                setEditRoom(prevRoom => {
                    if (type === 'image') {
                        return {
                            ...prevRoom,
                            images: data.request.images || []
                        };
                    } else if (type === 'video') {
                        return {
                            ...prevRoom,
                            videos: data.request.videos || []
                        };
                    }
                    return prevRoom;
                });
            }
        } catch (error) {
            console.error('Ошибка при удалении файла:', error);
            alert(translateAdmin('Произошла ошибка при удалении файла'));
        }
    };


    return (
        <div className='system-background-hide'>
            <section className="system-container system-container-form">
                <div className='system-container__inner'>
                    <header className="system-header"><AdminText>Редактирование</AdminText></header>
                    <form className="system-form">
                        <LanguageChanger />
                        <div className="system-input-box">
                            <label htmlFor="status"><AdminText>Показать/скрыть тип номера</AdminText></label>
                            <select required id="status" value={editRoom.status} name='status' onChange={handleInputChange}>
                                <option value="0"><AdminText>Скрыть</AdminText></option>
                                <option value="1"><AdminText>Показать</AdminText></option>
                            </select>
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Тип номера</AdminText></label>
                            <input required placeholder="" value={editRoom.translations.room_type[language] ? editRoom.translations.room_type[language] : ''} type="text" name='room_type' onChange={handleInputChange} />
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Общедоступные номера (количество)</AdminText></label>
                            <input required placeholder={translateAdmin("Общедоступные номера")} value={editRoom.count} type="number" name='count' onChange={handleInputChange} />
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Описание</AdminText></label>
                            <textarea placeholder="" value={editRoom.translations.description[language] ? editRoom.translations.description[language] : ''} type="text" name='description' onChange={handleInputChange}>
                            </textarea>
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Дополнительная информация</AdminText></label>
                            <textarea placeholder="" value={editRoom.translations.additional_info[language] ? editRoom.translations.additional_info[language] : ''} type="text" name='additional_info' onChange={handleInputChange}>
                            </textarea>
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Добавить фото/видео (максимум 7)</AdminText></label>
                            <input
                                type="file"
                                name="new_images"
                                accept="image/*,video/*"
                                onChange={handleFileChange}
                                multiple
                            />
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Все номера (количество)</AdminText></label>
                            <input required placeholder={translateAdmin("Все номера")} value={editRoom.count_total} type="number" name='count_total' onChange={handleInputChange} />
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Цена, летний сезон</AdminText></label>
                            <input required placeholder={translateAdmin("Число")} value={editRoom.price_summer} type="number" name='price_summer' onChange={handleInputChange} />
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Цена, зимний сезон</AdminText></label>
                            <input required placeholder={translateAdmin("Число")} value={editRoom.price_winter} type="number" name='price_winter' onChange={handleInputChange} />
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Максимальное количество гостей, которые могут разместиться в номере</AdminText></label>
                            <input required placeholder={translateAdmin("Число")} value={editRoom.capacity} type="number" name='capacity' onChange={handleInputChange} />
                        </div>
                        <div className="system-input-box">
                            <label><AdminText>Количество комнат в номере</AdminText></label>
                            <input required placeholder={translateAdmin("Число")} value={editRoom.rooms_count} type="number" name='rooms_count' onChange={handleInputChange} />
                        </div>
                    </form>
                </div>
                <div className="system-container__inner system-container__inner-images">
                    <div className="system-container__inner__images">

                        {/* Старая фотка */}
                        {editRoom.images.length > 0 &&
                            <>
                                <header className="system-header"><AdminText>Изображения</AdminText></header>
                                {editRoom.images.map((image, index) => (
                                    <div className='system-header__edit-image' key={`img-${index}`} onClick={() => delImageVideo(editRoom.id, image)}>
                                        <img src={apiUrl + `/api/images/${image}`} alt={`Room ${index}`} />
                                    </div>
                                ))}
                            </>
                        }
                        {/* Старое видео */}
                        {editRoom.videos.length > 0 &&
                            <>
                                <header className="system-header"><AdminText>Видео</AdminText></header>
                                {editRoom.videos?.map((video, index) => (
                                    <div
                                        className='system-header__edit-video'
                                        key={`video-${index}`}
                                        style={{ marginBottom: '20px', position: 'relative' }}
                                    >
                                        <video
                                            src={apiUrl + `/api/videos/${video}`}
                                            controls
                                            width="320"
                                            height="240"
                                            style={{ display: 'block' }}
                                        />
                                        {/* Кнопка удаления под видео */}
                                        <button
                                            className="delete-video-btn"
                                            onClick={() => delImageVideo(editRoom.id, video, "video")}
                                            style={{
                                                marginTop: '-15px',
                                                backgroundColor: '#e74c3c',
                                                color: '#fff',
                                                border: 'none',
                                                padding: '5px 10px',
                                                borderRadius: '4px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <AdminText>Удалить</AdminText>
                                        </button>
                                    </div>
                                ))}
                            </>
                        }
                    </div>
                    <form className="system-form">
                        {/* <div className="system-input-box">
                            <label><AdminText>Услуги</AdminText></label>
                            <button type="button" className='system-booking-table-btn system-booking-table-btn-view' onClick={handleAddAmenity}><AdminText>Добавить услугу</AdminText></button>
                            {editRoom.translations.amenities[language] ? (
                                editRoom.translations.amenities[language].map((amenity, index) => (
                                    <div key={index} className="amenity-item">
                                        <input
                                            placeholder={translateAdmin("Удобство")}
                                            value={amenity}
                                            type="text"
                                            onChange={(e) => handleAmenityChange(index, e.target.value)} />
                                        <button type="button" className='system-booking-table-btn system-booking-table-btn-cancel' onClick={() => handleRemoveAmenity(index)}><AdminText>Удалить</AdminText></button>
                                    </div>
                                ))
                            ) : null}
                        </div> */}
                        {/* <div className="system-input-box">
                            <label htmlFor="room_availability_id"><AdminText>Тип доступности номера</AdminText></label>
                            <select required id="room_availability_id" value={editRoom.room_availability_id} name='room_availability_id' onChange={handleInputChange}>
                                <option value={0} disabled><AdminText>Не выбрано</AdminText></option>
                                {roomAvailabilities.map((availability, index) => (
                                    <option key={index} value={availability.id}>{availability.title}</option>
                                ))}
                            </select>
                        </div> */}
                        <div className='flex-btns'>
                            <button type='button' className="system-booking-table-btn system-booking-table-btn-cancel" onClick={onClose}><AdminText>Закрыть</AdminText></button>
                            <button type='button' className="system-booking-table-btn system-booking-table-btn-view" onClick={() => sendData(editRoom)}><AdminText>Сохранить</AdminText></button>
                        </div>
                        {messageEditData ? (
                            Array.isArray(messageEditData) ? (
                                // Если это массив, рендерим каждый элемент в отдельном span
                                <div className="error-messages">
                                    {messageEditData.map((message, index) => (
                                        <span key={index} className='error-message'>{message}</span>
                                    ))}
                                </div>
                            ) : (
                                // Если это строка, выводим просто одну ошибку
                                <span className='error-message'>{messageEditData}</span>
                            )
                        ) : null}
                    </form>
                </div>
            </section>

        </div>
    );
}

export default RoomEdit;